import { render, staticRenderFns } from "./BerkleyActionsIssueProposal.vue?vue&type=template&id=bff4e590"
import script from "./BerkleyActionsIssueProposal.vue?vue&type=script&lang=js"
export * from "./BerkleyActionsIssueProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports